import React from 'react'
import PropTypes from 'prop-types'
import CustomChart from './CustomChart'
import useStatisticChart from '../../../../hooks/useStatisticChart'
import { downloadTypes } from '../../../../constants/statistics'

const InstitutionsChart = ({ results }) => {
  const headerNames = {
    institutions: 'Entidades'
  }
  const { chartData, chartTime } = useStatisticChart(results, ['Años', 'Entidades registradas'], headerNames)

  return (
    <CustomChart
      chartData={chartData}
      horizontalTitle={chartTime}
      verticalTitle="Cantidad de entidades"
      title="Entidades registradas"
      description="Revisa la cantidad de entidades usuarias de Facilita (con al menos un usuario registrado). Puedes usar los filtros para búsquedas específicas."
      downloadAvailable={[downloadTypes.picture, downloadTypes.monthlyExcel]}
      excelKindDownload="monthly_institutions"
    />
  )
}

export default InstitutionsChart

InstitutionsChart.propTypes = {
  results: PropTypes.object.isRequired
}
